import { Component, ViewEncapsulation, SimpleChanges, OnInit, OnChanges } from '@angular/core';

import { Observable } from 'rxjs';

import { ProductInfo, Merk, Model, Controltype, ProductType, Vraag, Antwoord } from '@models/claims';
import { SelectieItem, IBaseVraagboomResultaat, VraagboomAntwoord, VraagboomSelectieResultaat } from '@models/vragenboom';
import { DataService } from '../../../services/data.service';
import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { TextValidator } from '../../../utils/validation/text.validator';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-telefoon',
  templateUrl: './telefoon.component.html',
  styleUrls: ['./telefoon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TelefoonComponent extends BaseVraagControlDirective<VraagboomSelectieResultaat> implements OnInit, OnChanges {
  placeholder = '';
  filterAltijdTonen = 'overig';
  telefoonItems: SelectieItem[];
  huidigeSelectie: VraagboomSelectieResultaat;

  productInfo$: Observable<ProductInfo>;
  resultaten$: Observable<VraagboomAntwoord<IBaseVraagboomResultaat>[]>;
  codeMerk: string;
  merk: string;
  codeModel: string;
  model: string;
  performOnce = true;

  constructor(_dataService: DataService) {
    super(_dataService);
  }

  ngOnInit() {
    this.filterAltijdTonen = 'overig';
    this.telefoonItems = [];
    this.productInfo$ = this._dataService.productInfo;
    this.productInfo$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(pi => {
        if (pi !== undefined && pi !== null && pi.ok) {
          if (this.vraag.control === Controltype.Telefoon1) {
            this.vulGegevensMerk(pi);
          }
          if (this.vraag.control === Controltype.Telefoon2 || this.vraag.control === Controltype.Telefoon3) {
            this.resultaten$ = this._dataService.resultaten;
            this.resultaten$
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe(res => {
                if (this.performOnce) {
                  if (res !== undefined && res !== null) {
                    this.bewaarMerkModel(res);
                  }
                  if (this.vraag.control === Controltype.Telefoon2) {
                    this.vulGegevensModel(pi);
                  }
                  if (this.vraag.control === Controltype.Telefoon3) {
                    this.vulGegevensType(pi);
                  }
                  this.performOnce = false;
                }
              });
          }
        }
      });
  }

  initialize(changes: SimpleChanges): void {
    if (this.antwoordResultaat != null && this.antwoordResultaat.resultaat != null && this.antwoordResultaat.antwoorden != null) {
      // controleren of selectie nog mogelijk is voor model en type
      if ((this.vraag.control === Controltype.Telefoon1)
        || ((this.vraag.control === Controltype.Telefoon2 || this.vraag.control === Controltype.Telefoon3)
          && (this.telefoonItems.findIndex(i => i.code === this.antwoordResultaat.resultaat.code) > -1))) {
        this.huidigeSelectie = new VraagboomSelectieResultaat(this.antwoordResultaat.resultaat.code, this.antwoordResultaat.resultaat.titel, this.antwoordResultaat.resultaat.omschrijving);
      } else {
        this.huidigeSelectie = new VraagboomSelectieResultaat('', '', '');
        this.setAntwoord([], this.huidigeSelectie);
      }
    }
  }

  notifyAntwoord(selectie: VraagboomSelectieResultaat) {
    const antwoorden: Antwoord[] = [];
    if (this.vraag?.antwoorden?.length > 0) {
      antwoorden.push(this.vraag.antwoorden[0]);
    }
    this.setAntwoord(antwoorden, selectie);
  }

  vulGegevensMerk(productInfo: ProductInfo) {
    this.placeholder = 'Filter op merk';
    if (productInfo && productInfo.merken) {
      productInfo.merken.forEach((m: Merk) => {
        this.telefoonItems.push(new SelectieItem({ code: m.codeMerk, titel: m.omschrijvingMerk }));
      });
    }
  }

  vulGegevensModel(productInfo: ProductInfo) {
    this.placeholder = 'Filter op model';
    if (productInfo && productInfo.merken) {
      var prodInfoMerk = productInfo.merken.find(m => m.codeMerk === this.codeMerk);
      if (prodInfoMerk) {
        prodInfoMerk.modellen.forEach((m: Model) => {
          this.telefoonItems.push(new SelectieItem({ code: m.codeModel, titel: m.omschrijvingModel }));
        });
      }
    }
  }

  vulGegevensType(productInfo: ProductInfo) {
    this.placeholder = 'Filter op type';
    if (productInfo && productInfo.merken) {
      var prodInfoMerk = productInfo.merken.find(m => m.codeMerk === this.codeMerk);
      if (prodInfoMerk) {
        var prodInfoModel = prodInfoMerk.modellen.find(m => m.codeModel === this.codeModel);
        if (prodInfoModel) {
          prodInfoModel.productTypen.forEach((m: ProductType) => {
            this.telefoonItems.push(new SelectieItem({ code: m.codeType, titel: m.omschrijvingType }));
          });
        }
      }
    }
  }

  bewaarMerkModel(resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]): void {
    this.codeMerk = '';
    this.merk = '';
    this.codeModel = '';
    this.model = '';

    for (const resultaat of resultaten) {
      if (resultaat.vraag.control === Controltype.Telefoon1 || resultaat.vraag.control === Controltype.Telefoon2) {
        var telefoonResult = resultaat as VraagboomAntwoord<VraagboomSelectieResultaat>;
        if (resultaat.vraag.control === Controltype.Telefoon1) {
          this.codeMerk = telefoonResult.resultaat.code;
          this.merk = telefoonResult.resultaat.displayValue;
        }
        if (resultaat.vraag.control === Controltype.Telefoon2) {
          this.codeModel = telefoonResult.resultaat.code;
          this.model = telefoonResult.resultaat.displayValue;
        }
      }
    }
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomSelectieResultaat): boolean {
    return antwoorden?.length >= 1 && TextValidator.isValidSelectie(vraag, resultaat);
  }
}
